import { useMutation } from '@tanstack/react-query'

// Not apiFetch: the server puts the failure reason in the body of a non-ok
// response (e.g. "Session is incomplete, please start over"), and apiFetch
// throws it away — that message is what the alert shows.
const createInterests = async (interests) => {
  const response = await fetch('/api/user/interests', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(interests),
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data?.message || response.statusText)
  }

  return data
}

export const useCreateInterests = () =>
  useMutation({ mutationFn: createInterests })
